// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_u8-0";